<template>
  <div>
    <zone-table v-show="activeKey===1" ref="list" :putaway-modes="putawayModes" :transmission-types="transmissionTypes" :zone-types="zoneTypes" @add="add" @edit="edit" @enable="enable"/>
    <zone-detail v-show="activeKey===2" ref="detail" :fetch-modes="fetchModes" :operation-types="operationTypes" :packing-modes="packingModes" :position-types="positionTypes" :putaway-modes="putawayModes" :regions="regions" :seeding-modes="seedingModes" :staging-types="stagingTypes" :transmission-types="transmissionTypes" :zone-types="zoneTypes" @back="back"/>
  </div>
</template>

<script>
import ZoneTable from '@/views/basedata/zone/ZoneTable.vue'
import ZoneDetail from '@/views/basedata/zone/ZoneDetail.vue'
import { getDictionaries, getEnums } from '@/utils/util'

export default {
  name: 'ZoneBaseData',
  components: { ZoneTable, ZoneDetail },
  data() {
    return {
      activeKey: 1,
      zoneTypes: [],
      regions: [],
      fetchModes: [],
      putawayModes: [],
      transmissionTypes: [],
      seedingModes: [],
      packingModes: [],
      positionTypes: [],
      stagingTypes: [],
      operationTypes: []
    }
  },
  created() {
    getDictionaries('ZONE_REGION').then(result => {
      this.regions = result
      return getDictionaries('SEEDING_MODE')
    }).then(result => {
      this.seedingModes = result
      return getDictionaries('PACKING_MODE')
    }).then(result => {
      this.packingModes = result
      return getDictionaries('POSITION_TYPE')
    }).then(result => {
      this.positionTypes = result
      return getDictionaries('STAGING_TYPE')
    }).then(result => {
      this.stagingTypes = result
      return getEnums('ZoneType')
    }).then(result => {
      this.zoneTypes = result
      return getEnums('FetchMode')
    }).then(result => {
      this.fetchModes = result
      return getEnums('PutawayMode')
    }).then(result => {
      this.putawayModes = result
      return getEnums('TransmissionType')
    }).then(result => {
      this.transmissionTypes = result
      return getEnums('OperationType')
    }).then(result => {
      this.operationTypes = result
    })
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.refresh()
    },
    add() {
      this.activeKey = 2
      this.$refs.detail.add()
    },
    edit(row) {
      this.activeKey = 2
      this.$refs.detail.fetch(row.id)
    },
    enable(row, available) {
      this.$refs.detail.enable(row, available)
    }
  }
}
</script>